import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: 'rgs2/game/list',
  converter,
  gameListUrlData: {
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
  sessionUrlData: {
    url: 'rgs2/game/launch',
    getQuery: params => {
      const deviceType = params.isDesktop ? 1 : 2;
      // eslint-disable-next-line max-len
      return `?game_id=${params.gameId}&play_mode=1&device_type=${deviceType}&language=${
        shortLanguages[params?.lang as keyof typeof shortLanguages] ?? shortLanguages['es-es']
      }`;
    },
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
  },
};
